import React from "react";
import Paper from "@material-ui/core/Paper";
import Style from "../../styles/js/Styles";
import AlertItem from "./AlertItem.js";
import Divider from "@material-ui/core/Divider";

export default function ListAlerts({ alerts }) {
  const style = Style();

  return (
    <Paper className={style.listAlerts}>
      <div className={style.titlePaper}> Personas en movimiento </div>
      {alerts !== undefined &&
        alerts.map((alert, index) => (
          <div>
            <AlertItem key={index} alert={alert} />
            <Divider />
          </div>
        ))}
    </Paper>
  );
}
